"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The Stellenanzeige model module.
 * @module model/Stellenanzeige
 * @version 0.0.1
 */
class Stellenanzeige {
  /**
   * Constructs a new <code>Stellenanzeige</code>.
   * @alias module:model/Stellenanzeige
   * @param titel {String} 
   * @param beschreibung {String} 
   * @param ende {Date} 
   * @param id {Number} 
   * @param datum {Date} 
   */
  constructor(titel, beschreibung, ende, id, datum) {
    Stellenanzeige.initialize(this, titel, beschreibung, ende, id, datum);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, titel, beschreibung, ende, id, datum) {
    obj['titel'] = titel;
    obj['beschreibung'] = beschreibung;
    obj['ende'] = ende;
    obj['id'] = id;
    obj['datum'] = datum;
  }

  /**
   * Constructs a <code>Stellenanzeige</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Stellenanzeige} obj Optional instance to populate.
   * @return {module:model/Stellenanzeige} The populated <code>Stellenanzeige</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Stellenanzeige();
      if (data.hasOwnProperty('titel')) {
        obj['titel'] = _ApiClient.default.convertToType(data['titel'], 'String');
      }
      if (data.hasOwnProperty('beschreibung')) {
        obj['beschreibung'] = _ApiClient.default.convertToType(data['beschreibung'], 'String');
      }
      if (data.hasOwnProperty('ende')) {
        obj['ende'] = _ApiClient.default.convertToType(data['ende'], 'Date');
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
      if (data.hasOwnProperty('datei')) {
        obj['datei'] = _DateiBase.default.constructFromObject(data['datei']);
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
      }
      if (data.hasOwnProperty('datum')) {
        obj['datum'] = _ApiClient.default.convertToType(data['datum'], 'Date');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>Stellenanzeige</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Stellenanzeige</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of Stellenanzeige.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['titel'] && !(typeof data['titel'] === 'string' || data['titel'] instanceof String)) {
      throw new Error("Expected the field `titel` to be a primitive type in the JSON string but got " + data['titel']);
    }
    // ensure the json data is a string
    if (data['beschreibung'] && !(typeof data['beschreibung'] === 'string' || data['beschreibung'] instanceof String)) {
      throw new Error("Expected the field `beschreibung` to be a primitive type in the JSON string but got " + data['beschreibung']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    // validate the optional field `datei`
    if (data['datei']) {
      // data not null
      _DateiBase.default.validateJSON(data['datei']);
    }
    return true;
  }
}
Stellenanzeige.RequiredProperties = ["titel", "beschreibung", "ende", "id", "datum"];

/**
 * @member {String} titel
 */
Stellenanzeige.prototype['titel'] = undefined;

/**
 * @member {String} beschreibung
 */
Stellenanzeige.prototype['beschreibung'] = undefined;

/**
 * @member {Date} ende
 */
Stellenanzeige.prototype['ende'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
Stellenanzeige.prototype['bild'] = undefined;

/**
 * @member {module:model/DateiBase} datei
 */
Stellenanzeige.prototype['datei'] = undefined;

/**
 * @member {Number} id
 */
Stellenanzeige.prototype['id'] = undefined;

/**
 * @member {Date} datum
 */
Stellenanzeige.prototype['datum'] = undefined;
var _default = exports.default = Stellenanzeige;